<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Suzie Tullett</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><i>The Trouble with Words</i></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content"><i>Little White Lies and Butterflies</i></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content"><i>The French Escape</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-suzie-tullett.vue?860a21b4